import type { FinanceOptionType } from "../../../../common-deprecated/types/CommonTypes";
import type { UscCheckoutType } from "../../../shared-logic/types/UscCommonTypes";
import {
    type UscBasketActionsType,
    USC_BASKET_SET_FINANCE_OPTION,
    USC_BASKET_SET_CHECKOUT_TYPE,
} from "../actions/UscBasketActions";

export type UscBasketReducerType = {
    activeFinanceOption: FinanceOptionType;
    checkoutType: UscCheckoutType | null;
    configuration: unknown;
};

export const initialStateUscBasket: UscBasketReducerType = {
    activeFinanceOption: "cash",
    checkoutType: null,
    configuration: {},
};

const UscBasketReducer = (
    state: UscBasketReducerType = initialStateUscBasket,
    action: UscBasketActionsType,
): UscBasketReducerType => {
    switch (action.type) {
        case USC_BASKET_SET_FINANCE_OPTION: {
            return { ...state, activeFinanceOption: action.option };
        }

        case USC_BASKET_SET_CHECKOUT_TYPE: {
            return { ...state, checkoutType: action.checkoutType };
        }

        default:
            return state;
    }
};

export default UscBasketReducer;
